import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import Home from "@/pages/Home";
import SeguroAuto from "@/pages/SeguroAuto";
import SeguroEmpresarial from "@/pages/SeguroEmpresarial";
import SeguroVida from "@/pages/SeguroVida";
import Cotacao from "@/pages/Cotacao";
import Seguradoras from "@/pages/Seguradoras";
import Assistencia24h from "@/pages/Assistencia24h";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Sobre from "@/pages/Sobre";
import Contato from "@/pages/Contato";
import Admin from "@/pages/Admin";
import LojaOnline from "@/pages/LojaOnline";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-right" richColors closeButton />
      <AppLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/seguro-auto" element={<SeguroAuto />} />
          <Route path="/seguro-empresarial" element={<SeguroEmpresarial />} />
          <Route path="/seguro-de-vida" element={<SeguroVida />} />
          <Route path="/cotacao" element={<Cotacao />} />
          <Route path="/seguradoras" element={<Seguradoras />} />
          <Route path="/assistencia-24h" element={<Assistencia24h />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/loja-online" element={<LojaOnline />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
}

export default App;
